import { useGetManagerProfile } from "manager/hooks/api";

/** PRODUCT-2987 grant. Helper on /manager/profile/, not All Access. */
export const useCanSetPropertiesLive = () => {
  const { data: profile, isLoading, isError } = useGetManagerProfile();

  return {
    canSetPropertiesLive: Boolean(profile?.canSetPropertiesLive),
    isLoading,
    // First load or a failed first fetch: do not guess customer vs holder.
    // A later refetch can set isError while react-query still keeps profile.
    isUnresolved: !profile && (isLoading || isError),
  };
};

export default useCanSetPropertiesLive;
